export function convertToCents(price: number | string): number {
  return Math.round(+price * 100);
}

export function convertToEuros(price: number | string): number {
  return +price / 100;
}